// Swap "smart" punctuation pasted from Word, Google Docs, Outlook, etc. for its
// plain equivalent. One curly quote is enough to drop the SMS limit from 160 to
// 70, and recipients can't tell the difference. Accents and emoji are left
// alone: those were typed on purpose.
//
// Keep in sync with SmsText::REPLACEMENTS (lib/sms_text.rb), which applies the
// same swaps server-side before the length check.

const REPLACEMENTS: [RegExp, string][] = [
  [/[‘’‚‛′ʼ]/g, "'"], // curly single quotes, prime
  [/[“”„‟″]/g, '"'], // curly double quotes, double prime
  [/[‐‑‒–—―−]/g, '-'], // hyphens, en/em dashes, minus
  [/…/g, '...'], // ellipsis
  [/[  -   　]/g, ' '], // non-breaking and other spaces
  // Zero-width space, word joiner, BOM, soft hyphen. Not U+200C/U+200D: those
  // join emoji sequences (👩‍💻) and shape Persian and Indic scripts.
  [/[​⁠﻿­]/g, ''],
]

export function normalizeSmsText(str: string): string {
  return REPLACEMENTS.reduce((text, [pattern, replacement]) => text.replace(pattern, replacement), str)
}

// Normalize a textarea in place, keeping the cursor where it was. Returns
// true if the text changed.
export function normalizeTextarea(el: HTMLTextAreaElement): boolean {
  const original = el.value
  const text = normalizeSmsText(original)
  if (text === original) {
    return false
  }

  const caret = normalizeSmsText(original.slice(0, el.selectionStart ?? original.length)).length
  el.value = text
  if (document.activeElement === el) {
    el.setSelectionRange(caret, caret)
  }
  return true
}
